exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-card .caption[data-v-18fe9bf0]{font-size:8px!important}", ""]);

// exports
